// Pure data types shared by the React pages and the build-time pre-renderer.
// Keep this folder free of browser/React imports so vite.config can import it.

export interface ContentBlock {
  id?: string;
  heading?: string;
  level?: 2 | 3;
  paragraphs?: string[];
  list?: string[];
  /** Paragraph rendered directly after the list. */
  afterList?: string;
  cards?: { title: string; paragraphs: string[] }[];
  /** Question/answer pairs rendered as H3 + paragraph (on-page only, no FAQPage schema). */
  qa?: { q: string; a: string }[];
  links?: { href: string; label: string }[];
  note?: string;
}

export interface SeoPage {
  path: string;
  title: string;
  description: string;
  ogTitle?: string;
  ogDescription?: string;
  h1: string;
  intro?: string[];
  blocks: ContentBlock[];
  breadcrumbs: { name: string; path: string }[];
  jsonLd: Record<string, unknown>[];
  noindex?: boolean;
}

export const SITE_URL = "https://www.theventapp.com";
export const ORG_ID = `${SITE_URL}/#organization`;
export const OG_IMAGE =
  "https://storage.googleapis.com/gpt-engineer-file-uploads/a6PNZsWbRYbferCaxVAyqaLnRBW2/social-images/social-1764094146753-VENT_Black.png";

export const organizationLd = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "@id": ORG_ID,
  name: "Vent App LLC",
  alternateName: ["The Vent App", "Vent"],
  url: `${SITE_URL}/`,
  logo: `${SITE_URL}/vent-icon.png`,
  sameAs: ["https://www.instagram.com/the.vent.app/", "https://apps.apple.com/us/app/the-vent-app/id6757621490"],
  contactPoint: { "@type": "ContactPoint", email: "support@theventapp.com", contactType: "customer support" },
};

export const breadcrumbLd = (crumbs: { name: string; path: string }[]) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: crumbs.map((c, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name: c.name,
    item: `${SITE_URL}${c.path}`,
  })),
});
